import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsTransformationsTransformationId } from "@dashboardApi/apis/dataTransformation/constants";
import type {
  GenerateTransformationRequest,
  GenerateTransformationResponse,
} from "@dashboardApi/apis/dataTransformation/types";
import fetch from "@lib/fetch";

export const generateTransformation = reactQueryMutationAdapter(
  appsTransformationsTransformationId,
  async (request: GenerateTransformationRequest): Promise<GenerateTransformationResponse> => {
    return fetch(
      `/apps/transformations/${request.transformation_id}/generate`,
      "POST",
      request,
      {},
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
